// Typelizer digest 3024495e9e4059b31549990055e2c216
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /ideaboard/ideas/:idea_id/comments */
  create: (
    params: { ideaId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/ideaboard/ideas/:idea_id/comments', params, options),
    method: 'post',
  }),
}
